import moment from "moment";

function processEventsData(events){
    var now = moment().unix();

    var events_data = events.filter(event => moment(event.display_time).unix() <= now && moment(event.end_time).unix() > now)
    .map((row) => {
        var event = row;

        if (moment(event.display_time).unix() >= now) { // not active at all
            // row.color = "secondary";
            // row.icon = "archive";
            event.dateTime = moment(event.start_time).format("h:mm a, DD/MM/YY") + ' - ' + moment(event.end_time).format("h:mm a, DD/MM/YY");
            event.description = "Event displaying from: " + moment(event.display_time).format("h:mm a, DD/MM/YY");
            event.type = "inactive";
        }
        else if (moment(event.start_time).unix() >= now) { // displaying but not active
            // row.color = "warning";
            // row.icon = "notifications";
            event.dateTime = moment(event.start_time).format("h:mm a, DD/MM/YY") + ' - ' + moment(event.end_time).format("h:mm a, DD/MM/YY");
            event.description = "Event starting at: " + moment(event.start_time).format("h:mm a, DD/MM/YY");
            event.type = "warning";
        }
        else if (moment(event.start_time).unix() < now) { // active
            // row.color = "info";
            // row.icon = "campaign";
            event.dateTime = moment(event.start_time).format("h:mm a, DD/MM/YY") + ' - ' + moment(event.end_time).format("h:mm a, DD/MM/YY");
            event.description = "Event finishing at: " + moment(event.end_time).format("h:mm a, DD/MM/YY");
            event.type = "active";
        }

        // if (event.exception != null && event.exception != '') {
        //     row.badges.push(event.exception.replace("_", " "));
        // }

        // row.title = event.name;
        // row.lastItem = upcoming_events.length - 1 == index ? true : false;

        return event;
    });

    return events_data;
}

export {
    processEventsData
};